import { NavLink, Outlet, useNavigate } from "react-router-dom";

import { useAuth } from "../services/auth-context";

const STUDIO_NAV_ITEMS = [
  {
    to: "/studio",
    label: "Dashboard",
    icon: "M3 3h7v7H3zm11 0h7v7h-7zM3 14h7v7H3zm11 0h7v7h-7z",
    end: true,
  },
  {
    to: "/studio/invite",
    label: "Invita clienti",
    icon: "M22 2L11 13M22 2L15 22l-4-9-9-4 20-7z",
    end: false,
  },
  {
    to: "/studio/settings",
    label: "Impostazioni studio",
    icon: "M12 15a3 3 0 100-6 3 3 0 000 6zM19.4 15a1.65 1.65 0 00.33 1.82l.06.06a2 2 0 11-2.83 2.83l-.06-.06a1.65 1.65 0 00-1.82-.33 1.65 1.65 0 00-1 1.51V21a2 2 0 11-4 0v-.09A1.65 1.65 0 009 19.4a1.65 1.65 0 00-1.82.33l-.06.06a2 2 0 11-2.83-2.83l.06-.06a1.65 1.65 0 00.33-1.82 1.65 1.65 0 00-1.51-1H3a2 2 0 110-4h.09A1.65 1.65 0 004.6 9a1.65 1.65 0 00-.33-1.82l-.06-.06a2 2 0 112.83-2.83l.06.06a1.65 1.65 0 001.82.33H9a1.65 1.65 0 001-1.51V3a2 2 0 114 0v.09a1.65 1.65 0 001 1.51 1.65 1.65 0 001.82-.33l.06-.06a2 2 0 112.83 2.83l-.06.06a1.65 1.65 0 00-.33 1.82V9a1.65 1.65 0 001.51 1H21a2 2 0 110 4h-.09a1.65 1.65 0 00-1.51 1z",
    end: false,
  },
];

function NavIcon({ d }: { d: string }) {
  return (
    <svg
      width="15"
      height="15"
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
      aria-hidden="true"
      style={{ flexShrink: 0, opacity: 0.75 }}
    >
      <path d={d} />
    </svg>
  );
}

export function StudioShell() {
  const { tokens, logout } = useAuth();
  const navigate = useNavigate();
  const hasWorkspace = Boolean(tokens?.workspace_id);

  return (
    <div className="app-shell">
      <aside className="sidebar">
        <div className="brand-block">
          <div
            className="brand-logo"
            style={{
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              background: "linear-gradient(135deg, #6366f1, #8b5cf6)",
              color: "#fff",
              fontWeight: 800,
              fontSize: "0.85rem",
            }}
          >
            ST
          </div>
          <div>
            <h2>IncassaFlow</h2>
            <p>Dashboard Studio</p>
          </div>
        </div>

        {/* Toggle Studio ↔ App */}
        {hasWorkspace && (
          <div className="role-toggle">
            <button className="role-toggle-btn active" type="button">
              Studio
            </button>
            <button
              className="role-toggle-btn"
              type="button"
              onClick={() => navigate("/dashboard")}
            >
              App
            </button>
          </div>
        )}

        <nav className="sidebar-nav">
          {STUDIO_NAV_ITEMS.map((item) => (
            <NavLink
              key={item.to}
              to={item.to}
              end={item.end}
              className={({ isActive }) => (isActive ? "nav-link active" : "nav-link")}
            >
              <NavIcon d={item.icon} />
              {item.label}
            </NavLink>
          ))}
        </nav>

        <button
          type="button"
          className="ghost-btn"
          onClick={logout}
          style={{ marginTop: "auto" }}
        >
          &larr; Esci
        </button>
      </aside>

      <main className="page-content" id="main-content">
        <Outlet />
      </main>
    </div>
  );
}
